<template>
  <div class="nnmodal-title">Войти на сайт</div>

  <tabs class="mt-3 px-2" @select="clearInputs">
    <tab name="Войти по телефону" :selected="true">
      <checkout-input-phone @unset="unsetError('auth.phone')" :error="errors['auth.phone']" v-model="auth.phone" label="Телефон"></checkout-input-phone>
    </tab>
    <tab name="Войти по E-mail">
      <checkout-input @unset="unsetError('auth.email')" :error="errors['auth.email']" v-model="auth.email" label="E-mail"></checkout-input>
    </tab>
  </tabs>

  <checkout-input @unset="unsetError('auth.password')" :error="errors['auth.password']" v-model="auth.password" type="password" label="Пароль"></checkout-input>

  <div class="nnform-row">
    <checkout-checkbox class-name="nnform-text login-remember" v-model="auth.remember" label="Запомнить пароль"></checkout-checkbox>
    <div class="nnform-element-container m-0 login-recovery-wrapper">
      <a :href="linkRecovery" class="login-recovery nnform-text">Забыли пароль?</a>
    </div>
  </div>

  <div class="nnform-row login-button-group">
    <button type="button" class="login-button-group-item nnform-button --orange" @click="doLogin">Войти</button>
    <a :href="linkRegistration" class="login-button-group-item nnform-button --second">Зарегистрироваться</a>
  </div>
</template>

<script>
import CheckoutInputPhone from "../checkout/form/CheckoutInputMask.vue";
import CheckoutCheckbox from "../checkout/form/CheckoutCheckbox.vue";
import CheckoutInput from "../checkout/form/CheckoutInput.vue";
import Tabs from '../tabs/Tabs.vue';
import Tab from '../tabs/Tab.vue';
import axios from "axios";

export default {
  name: "Login",
  components: {
    Tabs,
    Tab,
    CheckoutInput,
    CheckoutInputPhone,
    CheckoutCheckbox,
  },
  data: function () {
    return {
      errors: {},
      auth: {
        email: null,
        phone: null,
        password: null,
        remember: false,
      },
    };
  },
  props: {
    linkRecovery: {
      type: String,
      default: null
    },
    linkRegistration: {
      type: String,
      default: null
    },
  },
  methods: {
    setError(key, message) {
      this.errors[key] = message;
    },
    unsetError(key) {
      this.errors[key] = false;
    },
    validateLoginForm() {

      if (!this.auth.email) {
        this.setError('auth.email', 'Введите E-mail адрес');
      }

      if (!this.auth.phone) {
        this.setError('auth.phone', 'Введите номер телефона');
      }


      if (this.auth.email) {
        this.unsetError('auth.phone');
      }
      if (this.auth.phone) {
        this.unsetError('auth.email');
      }

      if (!this.auth.password) {
        this.setError('auth.password', 'Введите пароль');
      }

    },
    hasErrorsLoginForm() {
      return this.errors['auth.phone'] && this.errors['auth.phone'] !== false
          || this.errors['auth.email'] && this.errors['auth.email'] !== false
          || this.errors['auth.password'] && this.errors['auth.password'] !== false;
    },
    doLogin() {
      this.validateLoginForm();

      if (this.hasErrorsLoginForm()) {
        return false;
      }

      axios.post('/ajax/login/', {
        email: this.auth.email,
        phone: this.auth.phone,
        password: this.auth.password,
        remember: this.auth.remember,
        action: 'login',
      }, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
          .then(response => {
            if (response.data.data.user) {
              this.$emit('success', response.data.data.user);
            }
          })
          .catch((error) => {
            this.$emit('error', error.response.data.message);
          });
    },
    clearInputs() {
      this.auth.email = null;
      this.auth.password = null;
      this.auth.phone = null;
    }
  }
}
</script>

<style scoped>

</style>